module.exports = __webpack_public_path__ + "img/img_25.18f12171.png";